import {observer} from "mobx-react";
import FontBody2 from "../../../../../../components/fonts/font-body2/font-body2";
import {FONT_COLOR, FONT_VARIANT} from "../../../../../../components/fonts/font-props";
import {FormField} from "../../../../../../components/form-field/form-field";
import IconEdit from "../../../../../../components/icons/icon-edit/icon-edit";
import IconPlus from "../../../../../../components/icons/icon-plus/icon-plus";
import {IconProps} from "../../../../../../components/icons/icon-props-interface";
import IconSolidLock from "../../../../../../components/icons/icon-solid-lock/icon-solid-lock";
import Icon from "../../../../../../components/icons/icon/icon";
import {ButtonIcon} from "../../../../../../components/inputs/button-icon/button-icon";
import ListLayout from "../../../../../../components/layouts/list-layout/list-layout";
import MediaUpload from "../../../../../../components/media-upload/media-upload";
import {Tooltip, TOOLTIP_VARIANTS} from "../../../../../../components/tooltip/tooltip";
import {FEATURES} from "../../../../../../models/Plan";
import currentPortalStore from "../../../../../../stores/current-portal-store";
import ProductCaseStore from "../../../stores/product-case-store";
import ValidateItemRow from "./validate-item-row";
import './validate-item.scss';
import FontHeading4 from "../../../../../../components/fonts/font-heading4/font-heading4";
import useDashboardTranslation from "../../../../../../dashboard-translation/hooks/dashboard-translation-hook";

interface IValidateItemWrapperProps {
    productCaseStore: ProductCaseStore;
}
const ValidateItemWrapper : React.FC<IValidateItemWrapperProps> = observer(({productCaseStore})=> {
    const itemReturnedStore = productCaseStore.validationReturnedStore;
    const itemCanBeRestockedStore = productCaseStore.validationCanBeRestockedStore;
    
    const isEditMode = productCaseStore.isValidationInEditMode;

    const { getTranslation } = useDashboardTranslation();
    const rmaCardScope = 'dashboard-returns-rma-card';
    
    const shouldDisplayImages = (() => {
        if(isEditMode && (!itemCanBeRestockedStore.isChecked || !itemReturnedStore.isChecked)){
            return true;
        }
        else if (productCaseStore.validationImages().length > 0){
            return true;
        }
        else {
            return false;
        }
        
    });
    
    let actionIcon: React.FC<IconProps>;
    if(!productCaseStore.isValidated){
        actionIcon = IconPlus
    }
    else {
        actionIcon = IconEdit;
    }
    const isFeatureAllowed = currentPortalStore.isFeatureAllowed(FEATURES.VALIDATE_ITEMS);
    return (
        <>
            <div className={'validate-item'}>
                <div className={'validate-item-header'}>
                    <div className={'validate-item-title'}>
                        <FontHeading4 variant={FONT_VARIANT.BOLD}>{getTranslation('ITEM_VALIDATION', rmaCardScope)}</FontHeading4>
                        {!isFeatureAllowed &&
                         <Tooltip content={
                                <FontBody2 color={FONT_COLOR.PRIMARY3_50}>
                                    {getTranslation('FEATURE_NOT_INCLUDED_DESCRIPTION', rmaCardScope)}
                                </FontBody2>
                             } variant={TOOLTIP_VARIANTS.TEXT}>
                             <Icon Component={IconSolidLock}/>
                        </Tooltip>
                        }
                    </div>
                    <ButtonIcon Component={actionIcon} disabled={productCaseStore.isValidationInEditMode || !isFeatureAllowed} onClick={() => {
                        productCaseStore.setValidateItemEditMode(true);
                    }}/>
                </div>
            {(productCaseStore.isValidated || isEditMode) &&
             <div>
                 <ListLayout>
                         <div>
                            <ValidateItemRow
                                disabledAndOff={false}
                                store={itemReturnedStore}
                                editMode={isEditMode}/>
                            <ValidateItemRow
                                disabledAndOff={!itemReturnedStore.isChecked}
                                store={itemCanBeRestockedStore}
                                editMode={isEditMode}/>
                        </div>
                     {shouldDisplayImages() &&
                      <FormField label={isEditMode ? getTranslation('ATTACH_FILES', rmaCardScope) : getTranslation('UPLOADED_MEDIA', rmaCardScope)} instructions={(isEditMode ? getTranslation('ATTACH_FILES_INSTRUCTIONS', 'dashboard-item-validation-popup') : undefined)}>
                            <MediaUpload uploadMedia={productCaseStore.onUploadValidationImage}
                                         onDelete={productCaseStore.onDeleteValidationImage}
                                         isEditMode={isEditMode}
                                         mediaFiles={productCaseStore.validationImages()}
                                         multiple
                                         buttonText={getTranslation('UPLOAD_IMAGE', 'dashboard-item-validation-popup')}
                            />
                        </FormField>
                     }
                    </ListLayout>
                 </div>
            }
            </div>
</>
)
});

export default ValidateItemWrapper;